import React from 'react';
import {
  Button,
  ButtonGroup,
  Link, Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from '@one-thd/sui-atomic-components';
import { ERROR_ALERT_TEXT, PRIVACY_PATH, SECURITY_PATH } from '../../constants';
import { formatPhone } from '../common/helper';
import { updateOrderPreferences } from '../../apis/orders';
import { determineSuccessText } from '../../apis/common';
import { confirmModalButton } from './ConfirmationModal';

function OrderStatusConfirmationModal(tableData, selected, phoneNumber, email, handleRetrieve, setOpenPhoneModal,
  setErrorBanners, setSuccessBanners) {

  function handleError() {
    setErrorBanners((prev) => [...prev, ERROR_ALERT_TEXT]);
  }

  const handleClose = () => {
    setOpenPhoneModal(false);
  };

  function handleSuccess(res) {
    setSuccessBanners((prev) => [...prev, determineSuccessText(selected, phoneNumber, email)]);
    handleRetrieve(res);
  }

  const handleConfirm = () => {
    setOpenPhoneModal(false);
    updateOrderPreferences(tableData, selected, (res) => {
      handleSuccess(res);
    },
    (err) => {
      handleError(err);
    });
  };

  return (
    <Modal open onClose={handleClose} data-testid="orderModal">
      <ModalHeader onClose={handleClose}>Use Contact Phone Number?</ModalHeader>
      <ModalBody>
        <Typography variant="body-lg">
          {`We found a phone number on your account and text messages will be sent to this
            phone number. To edit your phone number, please visit the `}
          <Link underline="always" href={SECURITY_PATH}>
            Security
          </Link>
          {` page before continuing
            to sign up for text messages.`}
        </Typography>
        <div className="sui-py-4">
          <Typography align="center" weight="bold">
            {formatPhone(phoneNumber)}
          </Typography>
        </div>
        <Typography variant="body-base">
          {`By clicking “Confirm,” you consent to The Home Depot contacting you at the number
            provided for order communications (“Order Texting Program”), including through the use of
            automated technology, SMS/MMS, and/or prerecorded, AI, or artificial messages. Messages
            are recurring. Consent is not a condition of purchase, and you may opt out of the Order
            Texting Program messages at any time by replying STOP or calling 800-525-5000.
            Msg & data rates may apply. You also agree to The Home Depot `}
          <Link underline="always" href={PRIVACY_PATH}>
            Privacy and Security Statement
          </Link>.
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <ButtonGroup>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" aria-label={confirmModalButton} onClick={handleConfirm}>Confirm</Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
}

export default OrderStatusConfirmationModal;
